import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import store from './store'
import router from './router'
import locale from 'element-ui/lib/locale/lang/en'
import VueClipboard from 'vue-clipboard2'
import Dayjs from 'vue-dayjs'
import VueLocalStorage from 'vue-localstorage'
import Notifications from 'vue-notification'
import device from 'vue-device-detector'

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true

Vue.use(ElementUI, { locale })
Vue.use(VueClipboard)
Vue.use(VueLocalStorage)
Vue.use(Notifications)
Vue.use(device)
Vue.use(Dayjs)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#demosmvoptions')
